import { ToggleButton, ToggleButtonProps, useTheme } from "@mui/material";

export const StyledToggleButton = (props: ToggleButtonProps) => {
  const theme = useTheme();

  return (
    <ToggleButton
      {...props}
      sx={{
        textTransform: "inherit",
        fontSize: "1rem",
        fontWeight: 400,
        // color: theme => theme.palette.text.primary,
        color: theme => theme.palette.text.primary,
        lineHeight: 1.5,
        borderTop: 0,
        marginTop: 0,
        "&.Mui-selected": {
          // color: theme => theme.typography.body1,
          color: theme.typography.body1,
          // backgroundColor: theme => theme.palette.background.paper,
          backgroundColor: theme.palette.background.paper,
          // "&:hover": {
          "&:hover": {
            // backgroundColor: theme => theme.palette.background.paper
            backgroundColor: theme.palette.background.paper
            // }
          }
        },
        ...props.sx // allows overrides
      }}
    />
  );
};
